import { GetLocationsDocument, GetLocationsQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type LocationNodes = GetLocationsQuery['locations']['locations']
export type TLocationsLocation = LocationNodes[number]
export const useLocations = () => {
  const { error, loading, data } = useQuery(GetLocationsDocument)

  return {
    error,
    loading,
    locations: data ? data.locations.locations : [],
  }
}
